<nav id="nav-header" class="navbar navbar-expand-lg navbar-light nav-header-pfm py-3 py-lg-0" [style.opacity]="headerStyles.opacity" [ngClass]="headerStyles.class!" [class.header-pci-compact]="isCompactHeader">
  <div class="container-fluid p-0">
    <div class="col-4 col-md-2 ps-1 px-md-3 px-lg-5 header-pci-logo-container">
      <img
        loading="eager"
        decoding="async"
        fetchpriority="high"
        [src]="environment.assetsURL + 'img/logos/ssl-encryption.webp'"
        width="624"
        height="250"
        class="img-fluid"
        alt="SSL encryption">
    </div>

    <div class="col-4 col-md-2 pe-1 px-md-2 py-lg-2 px-xxl-4 text-center header-pci-brand-container" *ngIf="FunnelFlow.PathLogo; else ImagePFMDefault">
      <img
        loading="eager"
        decoding="async"
        fetchpriority="high"
        [src]="FunnelFlow.PathLogo"
        [ngClass]="{'header-cobrand-logo-verify': showClassVerify, 'header-cobrand-logo': !showClassVerify}"
        alt="Brand logo"
        bh-id="2-step-banner-cobrand-img">
    </div>

    <ng-template #ImagePFMDefault>
      <div class="col-4 col-md-2 pe-1 px-md-3 px-lg-5 header-pci-brand-container">
        <img
          loading="eager"
          decoding="async"
          fetchpriority="high"
          [src]="currentLogo"
          width="160"
          height="64"
          [ngClass]="{'header-cobrand-logo-verify': showClassVerify, 'header-cobrand-logo img-fluid': !showClassVerify}"
          alt="Brand logo"
          bh-id="2-step-banner-default-logo-img">
      </div>
    </ng-template>
  </div>
</nav>